<button mat-raised-button (click)="viewPDFBtnClick()"  >
  <mat-icon aria-hidden="false" aria-label="Vizualizeaza Document"> insert_drive_file</mat-icon>

</button>
